module.exports = __webpack_public_path__ + "img/poster4.618a38cc.jpg";